import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 200);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-[#0d0d0d]/96 backdrop-blur-md border-b border-white/[0.06]">
      <div className="w-full px-6 md:px-10 lg:px-16">
        <div className="flex items-center justify-center h-16 md:h-20">
          <Link to="/" className="flex items-center gap-3">
            <span className={`text-base font-bold tracking-[0.16em] uppercase transition-colors duration-300 ${scrolled ? "text-[#B8422E]" : "text-white"}`}>
              Trevionix Help
            </span>
            <span className="w-px h-4 bg-white/20" />
            <span className={`text-[11px] tracking-[0.12em] uppercase transition-colors duration-300 ${scrolled ? "text-[#B8422E]/70" : "text-[#6C7278]"}`}>
              LTD
            </span>
          </Link>
        </div>
      </div>
    </nav>
  );
}
